import { gql } from "@apollo/client";

export const GET_BANK_DETAILS_BY_ID = gql`
query GetBankDetailsById {
  getBankDetailsById {
    id
    customerId
    bankHolderName
    ifscCode
    accountNumber
    bankName
    accountType
    gstNumber
    gstImage
    cancelledCheckImage
    panCardImage
    aadhaarCardImage
    createdAt
    state
    city
    branch
  }
}
`

export const GET_CUSTOMER_BANK_DETAILS = gql`
query GetBankDetails($customerId: String) {
  getBankDetails(customerId: $customerId) {
  count
  data{
    id
    customerId
    bankHolderName
    ifscCode
    accountNumber
    bankName
    accountType
    gstNumber
    gstImage
    cancelledCheckImage
    panCardImage
    aadhaarCardImage
    createdAt
    state
    city
    branch
    }
  }
}
`